import React, { useEffect, useState } from "react";
import { InlineStack, Text, Box } from "@shopify/polaris";

import { GetSupportTickets } from "../../services/supportTicket";
import SupportTicketsTable from "../../components/SupportTickets/SupportTicketTable";
import CreateSupportTicketForm from "./Create";

const SupportDashboard = () => {
  const [supportTickets, setSupportTickets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchSupportTickets = async () => {
    const { data } = await GetSupportTickets(currentPage);
    if (data.result) {
      setSupportTickets(data.result);
    }
  };

  useEffect(() => {
    fetchSupportTickets();
  }, [currentPage]);
  return (
    <>
      <br />

      <br />
      <InlineStack blockAlign="start" align="space-between">
        <Box width="60%">
          <>
            <Text variant="headingLg">Support Tickets</Text>
            <br />
            <SupportTicketsTable
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              tickets={supportTickets}
            />
          </>
          {/* )} */}
        </Box>
        <Box>
          <Text variant="headingLg">Support Tickets</Text>
          <br />
          <CreateSupportTicketForm fetchTickets={fetchSupportTickets} />
        </Box>
      </InlineStack>

      <br />

      <br />
    </>
  );
};

export default SupportDashboard;
